import { AppHelper } from "../appHelper"
import { CommonApp, Entity } from "../core/components/commonApp";
import { Helper } from "../core/util/helper";
import { NotificationHelper } from "../core/util/notificationHelper";
import { HTTPService } from "../core/util/httpManager";
import { GridCustomToolBarButton, ToolBarStandardButtonType } from "../core/components/toolBar";
import { Grid } from "../core/components/grid";
import { General } from "../../siteManagement/general";
import { EventType } from "../../siteManagement/eventManager";
import { StringKeyDictionary } from "../commonInterfaces";
import React from "react";


export default class ServerJobApp extends React.Component<ServerJobProps, any> {
    common = new AppHelper();
    translations: StringKeyDictionary<string> = null;
    private resourceGridOptions;
    private _resourceGridRef: Grid;
    private _selectedNkns = [];



    constructor(props) {
        super(props);
        this.common.enableHooks = true;
        this.common.init(this);
        this.props.context.translations = this.translations;
        this.resourceGridOptions = {
            sortable: true,
            pageable: false,
            groupable: false,
            filterable: true,
            selectable: true,
            resizable: false,
            scrollable: true,
            columns: [
                {
                    field: "Ressnr",
                    title: this.translations["Field.Ressource.ressnr"],
                    width: 65
                },
                {
                    field: "Vorname",
                    title: this.translations["Field.Ressource.vorname"],
                    width: 65
                },
                {
                    field: "Name",
                    title: this.translations["Field.Ressource.name"],
                    width: 65
                },
                {
                    field: "Gruppe",
                    title: this.translations["Field.Ressource.gruppe"],
                    width: 65
                },
                {
                    field: "Obergruppe",
                    title: this.translations["Field.Ressource.obergruppe"],
                    width: 65
                },
                {
                    field: "Active",
                    title: this.translations["WebSMS.DataExchangeModule.File.Activ"],
                    template: "# if(Active == 1) {#<div class='grid-icon-custom-center' style='color:black'><i class='fal fa-thumbs-up' title='"
                        + this.translations["WebSMS.DataExchangeModule.File.Activ"]
                        + "'></i></div>#}else if(data.Active == 0){#<div class='grid-icon-custom-center' style='color:black'><i class='fal fa-ban' title='"
                        + this.translations["WebSMS.DataExchangeModule.File.Inactiv"]
                        + "'></i></div> #}#",
                    width: 65
                },
                {
                    field: "ReciveFiles",
                    title: this.translations["WebSMS.DataExchangeModule.File.SendOn"],
                    template: "#if(ReceiveFiles != null) {##= kendo.toString(kendo.parseDate(ReceiveFiles), 'd') ##}#",
                    width: 65
                },
                {
                    field: "Zipname",
                    title: this.translations["WebSMS.DataExchangeModule.File.Zipname"],
                    width: 65
                },
            ]
        }
        this.state = {
            enableDeactivateButton: false
        };
        General.Events.bind(EventType.Custom, this.setEvents);
    }
    private setEvents = (cus: { command: string }) => {
        switch (cus.command) {
            case "reloadSiteAfterExecute":
                HTTPService.get("ServerJob/InitData?id=" + this.props.entity.Jobid).then(result => {

                    Helper.updateEntity(this.props.entity, result.Data);
                    let copyEntity = JSON.parse(JSON.stringify(this.props.entity));
                    copyEntity.IsInExecution = true;
                    Helper.updateEntity(this.props.entity, copyEntity);
                    this.setState({});
                });
                break;
        }
    }

    fillResourceGrid = () => {
        HTTPService.post("ServerJob/FillResourceList", this.props.entity)
            .then(result => {
                if (result.Code === 0) {
                    Helper.updateEntity(this.props.entity, result.Data);
                    this.setState({});
                } else {
                    NotificationHelper.showErrorMessage(result.Message);
                }
            });
    }
    private activateRessources = (nkns: string[]) => {
        for (let i = 0; i < nkns.length; i++) {
            let item = Helper.getArrayItem(this.props.entity.Resources, "Nkn", nkns[i]);
            item.Active = ResourceState.Active;
        }
        this.common.setEntityDirtyState(true);
        let selectedPage = this._resourceGridRef.getGridRef().dataSource.page();
        this.setState({}, () => { this._resourceGridRef.getGridRef().dataSource.page(selectedPage); this._resourceGridRef.getGridRef().refresh() });

    }
    private deactivateRessource = (nkn) => {
        let item = Helper.getArrayItem(this.props.entity.Resources, "Nkn", nkn);
        item.Active = ResourceState.Inactive;
        this.common.setEntityDirtyState(true);
        let selectedPage = this._resourceGridRef.getGridRef().dataSource.page();
        this.setState({}, () => { this._resourceGridRef.getGridRef().dataSource.page(selectedPage); this._resourceGridRef.getGridRef().refresh() });

    }
    private handleCustomButton = (id: string, dataItem) => {
        if (id === "activate") {
            let nkn = [];
            nkn.push(dataItem.Nkn);
            this.activateRessources(nkn);
        } else if (id === "activateall") {
            this._selectedNkns.length = 0;
            var dataSource = this._resourceGridRef.getGridRef().dataSource;
            var filters = dataSource.filter();
            var allData: any = dataSource.data();
            var query = new kendo.data.Query(allData);
            var data = query.filter(filters).data;
            for (var i = 0; i < data.length; i++) {
                this._selectedNkns.push(data[i].Nkn);
            }
            this.activateRessources(this._selectedNkns);
        } else if (id == "deactivate") {
            this.deactivateRessource(dataItem.Nkn);

        }
    }
    onSelectionChanged = (dataItem) => {
        if (Helper.hasValue(dataItem))
            this.setState({ enableDeactivateButton: !Helper.hasValue(dataItem.ReceiveFiles) });
    }
    executeJob = () => {
        HTTPService.post("ServerJob/ExecuteJob", this.props.entity)
            .then(result => {
                if (result.Code === 0) {
                    Helper.updateEntity(this.props.entity, result.Data);
                    this.common.setEntityDirtyState(false);
                    this.setState({});
                } else {
                    NotificationHelper.showErrorMessage(result.Message);
                }
            });
    }
    isExecuteable = () => {
        return (!this.props.entity.IsNew
            && !this.props.entity.IsInExecution
            && this.props.entity.Resources?.filter(res => res.Active == ResourceState.Active
                && !Helper.hasValue(res.ReceiveFiles)).length > 0
            && this.props.entity.FileNames?.filter(file => !file.Deleted).length > 0);
    }
    renderResourceGrid = () => {
        let canActivate = (Helper.hasValue(this.props.entity.Resources) && this.props.entity.Resources?.length > 0);
        const customButtom: Array<GridCustomToolBarButton> = [];
        customButtom.push({ autoEnabledOnRecordSelected: true, caption: this.translations["WebSMS.DataExchangeModule.File.Activate"], enabled: true, id: "activate", iconClass: "k-i-redo" });
        customButtom.push({ autoEnabledOnRecordSelected: false, caption: this.translations["WebSMS.DataExchangeModule.File.ActivateAll"], enabled: canActivate, id: "activateall", iconClass: "k-i-redo" });
        customButtom.push({ autoEnabledOnRecordSelected: true, caption: this.translations["WebSMS.DataExchangeModule.File.Deactivate"], enabled: this.state.enableDeactivateButton, id: "deactivate", iconClass: "k-i-redo" });
        let grid = (
            <Grid data={this.props.entity.Resources} options={this.resourceGridOptions} id="resourcegrid"
                customButtons={customButtom} onClickCustomButton={this.handleCustomButton} onSelectionChanged={this.onSelectionChanged}
                ref={(r) => this._resourceGridRef = r}
            />
        );
        return (grid)
    }
    save = () => {
        if (this.common.validate()) {
            HTTPService.post("ServerJob/Save", this.props.entity)
                .then(result => {
                    if (result.Code === 0) {
                        NotificationHelper.showSuccessMessage(result.Message);
                        Helper.updateEntity(this.props.entity, result.Data);
                        if (!Helper.hasValue(this.props.entity.Resources)){
                            let copiedEntity = JSON.parse(JSON.stringify(this.props.entity));
                            copiedEntity.Resources= [];
                            Helper.updateEntity(this.props.entity,copiedEntity);
                        }
                        General.Functions.HistoryState.replaceState("ServerJob/Edit?id=" + encodeURIComponent(this.props.entity.Jobid));
                        this.common.handlePostSave(result.Code === 0, false);
                    } else {
                        NotificationHelper.showErrorMessage(result.Message);
                    }
                });
        }
    }
    handleFieldChange = (field, value, dataItem = null, isInit = false) => {
        let entityWasChanged = this.common.entityChanged;

        if (!isInit)
            this.common.handleFieldChange(field, value, dataItem);

        switch (field.model) {
            case "entity.RessourceTyp":
                if (!entityWasChanged)
                    this.common.setEntityDirtyState(false);
                break;
            case "entity.AuswahlEmpfaengerRessource":
                if (!entityWasChanged)
                    this.common.setEntityDirtyState(false);
                break;
            case "entity.AuswahlEmpfaengerGruppe":
                if (!entityWasChanged)
                    this.common.setEntityDirtyState(false);
                break;
            case "entity.AuswahlEmpfaengerObergruppe":
                if (!entityWasChanged)
                    this.common.setEntityDirtyState(false);
                break;
            case "entity.FileNames":
                if (!entityWasChanged)
                    this.common.setEntityDirtyState(false);
            default:
                break;
        }
    }
    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps(), { handleFieldChange: this.handleFieldChange });
        return <CommonApp {...props} />;
    }
};
enum ResourceState {
    Inactive,
    Active
}
export interface ServerJobProps {
    context: {
        translations: StringKeyDictionary<string>;
    }
    field: any;
    entity: ServerJobEntity;
    onChange: (field, value) => void
}
export interface ServerJobEntity extends Entity {
    Jobid: number;
    Resources: Array<ResourceToActivate>;
    FileNames: Array<FileSelect>;
    IsInExecution: boolean;
}
export interface ResourceToActivate {
    Ressnr: string;
    Vorname: string;
    Name: string;
    Gruppe: string;
    Obergruppe: string;
    Active: ResourceState;
    Nkn: string;
    ReceiveFiles: Date;
}
export interface FileSelect {
    Name: string;
    Pos: number;
    Remark: string;
    Filesize: number;
    Deleted: boolean;
}